import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import React from 'react';
import { Manager, Popper, Reference } from 'react-popper';
import { shadow1 } from '../styles/util';
import { TooltipArrow } from './TooltipBuilder.styled';
export var TooltipBuilder = function TooltipBuilder(props) {
  var placementOrDefault = props.placement || 'top';
  return /*#__PURE__*/React.createElement(Manager, null, /*#__PURE__*/React.createElement(Reference, null, props.renderHoverTrigger), props.tooltipVisible && /*#__PURE__*/React.createElement(Popper, {
    strategy: "fixed",
    placement: placementOrDefault,
    modifiers: [{
      name: 'offset',
      options: {
        offset: [0, 15]
      }
    }, {
      name: 'preventOverflow',
      options: {
        altAxis: true
      }
    }, {
      name: 'flip'
    }, {
      name: 'computeStyles',
      options: {
        gpuAcceleration: false
      }
    }]
  }, function (_ref) {
    var ref = _ref.ref,
      style = _ref.style,
      placement = _ref.placement,
      arrowProps = _ref.arrowProps;
    var _getPositionStyles = getPositionStyles(placement),
      arrowPositionStyles = _getPositionStyles.arrowPositionStyles,
      contentPositionStyles = _getPositionStyles.contentPositionStyles;
    return props.renderTooltip({
      ref: ref,
      style: _objectSpread(_objectSpread({}, style), contentPositionStyles)
    }, /*#__PURE__*/React.createElement(TooltipArrow, {
      ref: arrowProps.ref,
      style: _objectSpread(_objectSpread({}, arrowProps.style), arrowPositionStyles)
    }));
  }));
};
function getPositionStyles(placement) {
  var arrowPositionStyles = {};
  var contentPositionStyles = {};
  switch (placement) {
    case 'top':
      arrowPositionStyles.bottom = '-5px';
      arrowPositionStyles.boxShadow = shadow1.boxShadow;
      // arrow can't be placed behind the tooltip content element due to popper.js limitations,
      // so clip off the top to prevent the box shadow from leaking a bit onto the tooltip
      arrowPositionStyles.clipPath = 'inset(0 -5px -5px 0)';
      break;
    case 'bottom':
      arrowPositionStyles.top = '-5px';
      break;
    case 'right':
      arrowPositionStyles.left = '-5px';
      arrowPositionStyles.boxShadow = shadow1.boxShadow;
      break;
    case 'left':
      arrowPositionStyles.right = '-5px';
      arrowPositionStyles.boxShadow = shadow1.boxShadow;
      break;
  }
  return {
    arrowPositionStyles: arrowPositionStyles,
    contentPositionStyles: contentPositionStyles
  };
}